import * as yup from "yup";
// import 'yup-phone'
import "yup-phone-lite";
import { US_ORG_TIMEZONE_VALUES } from "@/constants/usOrgTimezones";

export const AuthSchema = yup.object({
  email: yup
    .string()
    .trim()
    .required("Email or mobile is required")
    .test(
      "email-or-phone",
      "Enter a valid email or mobile number",
      (value) => {
        if (!value || !value.trim()) return false;
        const trimmed = value.trim();
        const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
        const digitsOnly = trimmed.replace(/\D/g, "");
        const isPhone = digitsOnly.length >= 10 && digitsOnly.length <= 15;
        return isEmail || isPhone;
      }
    ),
  password: yup
    .string()
    .required("Password is required")
    .min(8, 'Error: "Password should be greater than 8"'),
});

export const npiSearchSchema = yup.object({
  search: yup
    .string()
    .required("NPI Provider is required")
    .min(10, "NPI Provider is of 10 digits"),
});
export const CommonFieldSchema = {
  firstName: yup.string().required("First Name is required"),
  middleName: yup.string(),
  lastName: yup.string().required("Last Name is required"),
  dateOfBirth: yup.string().required("Date of Birth is required"),
  street: yup.string().required("Street is required"),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  zipcode: yup
    .string()
    .required("Zipcode is required")
    .test("zipcode", "Invalid Zip Code", (value) => {
      // if (value == "") return true;
      // else 
        return !!value?.match(/^[0-9]{5}(-[0-9]{4})?$/);
    }),

  email: yup
    .string()
    .required("Email is required")
    .email("Invalid email format"),
  phone: yup
    .string()
    .phone("Invalid phone number", "Invalid phone number")
    .required("Phone Number is required"),
  gender: yup.string().required("Gender is required"),
  status: yup.string().required("Status is required"),
  timezone: yup
    .string()
    .required("Timezone is required")
    .oneOf(US_ORG_TIMEZONE_VALUES, "Invalid timezone"),
};

export const ProviderSchema = {
  organizationId: yup.string().required("Organization is required"),
  // zipcode: yup
  //   .string()
  //   .optional()
  //   .default("")
  //   .test("zipcode", "Invalid Zip Code", (value) => {
  //     if (!value || value === "") return true;
  //     return !!value?.match(/^[0-9]{5}(-[0-9]{4})?$/);
  //   }),
  npiNumber: yup
  .string()
  .required("Npi number is required")
  .length(10, "Npi number must be exactly 10 digits"),

  specializations: yup
    .array()
    .of(yup.string().required("Specialization is required"))
    .min(1, "Atleast 1 specializations is required")
    .required("Atleast 1 specializations is required"),
  taxonomies: yup
    .array()
    .of(yup.string().required("Taxonomy is required"))
    .min(1, "Atleast 1 taxonomies is required")
    .required("Atleast 1 taxonomies is required"),
};

export const PractitionerSchema = {
  organizationId: yup.string().required("Organization is required"),
  providerId: yup.string().required("Provider is required"),
  // zipcode: yup
  //   .string()
  //   .optional()
  //   .default("")
  //   .test("zipcode", "Invalid Zip Code", (value) => {
  //     if (!value || value === "") return true;
  //     return !!value?.match(/^[0-9]{5}(-[0-9]{4})?$/);
  //   }),
  npiNumber: yup
  .string()
  .required("Npi number is required")
  .length(10, "Npi number must be exactly 10 digits"),

  specializations: yup
    .array()
    .of(yup.string().required("Specialization is required"))
    .min(1, "Atleast 1 specializations is required")
    .required("Atleast 1 specializations is required"),
  taxonomies: yup
    .array()
    .of(yup.string().required("Taxonomy is required"))
    .min(1, "Atleast 1 taxonomies is required")
    .required("Atleast 1 taxonomies is required"),
};

export const CaretakerSchema = {
  // zipcode: yup.string().optional().default(""),
  assignedOrganizations: yup
    .array()
    .of(yup.string().required())
    .min(1, "Assigned Organizations is required")
    .required("Assigned Organizations is required"),
  type: yup
    .string()
    .required("Type of is required")
    .oneOf(["facility", "no_facility", "all"], "Invalid type selection"),
};

export const organizationValidationSchema = yup.object().shape({
  // Step 1: General Details
  ownerFirstName: yup.string().required("Owners First Name is required").trim(),
  ownerMiddleName: yup.string().trim(),
  ownerLastName: yup.string().required("Owners Last Name is required").trim(),
  organizationName: yup
    .string()
    .required("Name of Organization is required")
    .trim(),
  timezone: yup
    .string()
    .optional()
    .oneOf(US_ORG_TIMEZONE_VALUES, "Invalid timezone")
    .default("America/New_York"),
  providerGroupType: yup
    .string()
    .required("Provider / Group NPI type is required"),
  providerGroupNPI: yup
  .string()
  .required("Npi number is required")
  .length(10, "Npi number must be exactly 10 digits")
,
  phoneNumber: yup
    .string()
    .phone("Invalid Phone Number", "Invalid Phone Number")
    .required("Phone Number is required"),
  email: yup
    .string()
    .required("Email is required")
    .email("Email must be valid")
    .trim()
    .lowercase(),
  address: yup.string().required("Address is required").trim(),
  // street: yup.string().required("Street is required").trim(),
  city: yup.string().required("City is required").trim(),
  state: yup.string().required("State is required").trim(),
  zipCode: yup.string().
  required("Zip Code is required").
  test("zipcode", "Invalid Zip Code", (value) => {
     return !!value?.match(/^[0-9]{5}(-[0-9]{4})?$/);
  }).trim(),
  // address2: yup.string().trim(),
  // street2: yup.string().trim(),
  // city2: yup.string().trim(),
  // state2: yup.string().trim(),
  // zipCode2: yup
  //   .string()
  //   .test("zipcode", "Invalid Zip Code", (value) => {
  //     if (value == "") return true;
  //     else return !!value?.match(/^[0-9]{5}(-[0-9]{4})?$/);
  //   })
  //   // .matches(/^[0-9]{5}(-[0-9]{4})?$/, 'Zip Code must be valid')
  //   .trim(),

  // Step 2: Biller Details
  billerFirstName: yup.string().required("First Name is required").trim(),
  billerMiddleName: yup.string().trim(),
  billerLastName: yup.string().required("Last Name is required").trim(),
  billerPhoneNumber: yup
    .string()
    .phone("Invalid Phone Number", "Invalid Phone Number")
    .required("Phone Number is required"),
  billerEmail: yup
    .string()
    .required("Email is required")
    .email("Email must be valid")
    .trim()
    .lowercase(),
  // billerLocation: yup.string().required("Location is required").trim(),
  billerAddress: yup.string().required("Address is required").trim(),
  billerStreet: yup.string().required("Street is required").trim(),
  billerCity: yup.string().required("City is required").trim(),
  billerState: yup.string().required("State is required").trim(),
  billerZipCode: yup.string().optional().default("").trim(),
  // billingPortalUsed: yup.string().trim(),

  // Step 3: Billing Information
  groupName: yup.string().required("Group Name is required").trim(),
  billingAddress: yup.string().required("Address is required").trim(),
  billingStreet: yup.string().required("Street is required").trim(),
  billingCity: yup.string().required("City is required").trim(),
  billingState: yup.string().required("State is required").trim(),
  billingZipCode: yup.string().optional().default("").trim(),
  primaryFax: yup
    .string()
    .matches(/^[0-9\s\-\+\(\)]*$/, "Primary Fax must be valid")
    .trim(),
  primaryPhoneNumber: yup
    .string()
    .phone("Invalid Phone Number", "Invalid Phone Number")
    .required("Phone Number is required"),
  groupTaxId: yup.string().trim(),
  groupNPI: yup.string().trim(),
  ptan: yup.string().trim(),
  tradingPartnerId: yup.string().trim(),
  tin: yup.string().trim(),
  medicalId: yup.string().trim(),
  taxonomyCode: yup.string().trim(),
});

export const patientValidationSchema = yup.object().shape({
  // Organization & Assignment
  organizationId: yup.string().required("Organization is required"),
  facilityId: yup
    .string()
    .when("typeOfPatient", {
      is: (v: any) => v === "facility",
      then: (schema) => schema.required("Facility is required for Facility patient type"),
      otherwise: (schema) => schema.optional().nullable(),
    }),
    // primaryContactPerson
    primaryContactPerson : yup.string().required("Primary Contact Person is required"),
  assignedProviderId: yup.string().required("Assigned Provider is required"),
  // assignedCaretakerIds: yup.array(),

  // Personal Information
  firstName: yup.string().required("First Name is required").trim(),
  middleName: yup.string().trim(),
  lastName: yup.string().required("Last Name is required").trim(),
  dateOfBirth: yup
    .string()
    .required("Date of Birth is required")
    .test("dateOfBirth", "Must be a valid date", (value) => {
      if (!value) return false;
      const date = new Date(value);
      return date instanceof Date && !isNaN(date.getTime());
    })
    .test("dateOfBirth", "Date of Birth cannot be in the future", (value) => {
      if (!value) return true;
      return new Date(value) <= new Date();
    }),
  gender: yup
    .string()
    .required("Gender is required")
    .oneOf(["male", "female", "others"], "Invalid gender selection"),
  // heightValue: yup
  //   .string()
  //   .required("Height is required")
  //   .trim(),
  // height_feet: yup
  //   .string()
  //   .required("required")
  //   .trim(),
  // height_inch: yup
  //   .string()
  //   .required("required")
  //   .trim(),
  weightValue: yup
    .string()
    // .required("Weight is required")
    .trim(),
  typeOfPatient: yup.string().required("Patient type is required"),
  facilityRoom: yup
  .string()
  .when("typeOfPatient", {
    is: (val :any) => val === "facility",
    then: (schema) =>
      schema.required("Facility room is required for facility patients"),
    otherwise: (schema) => schema.optional(), // allows empty string
  }),
  // .oneOf(["ccm", "rpm", "pcm", "bhi"], "Invalid patient type"),
  // status: yup
  //   .string()
  //   .required("Status is required")
  //   .oneOf(["active", "pending", "inactive"], "Invalid status"),

  // Contact Information
  email: yup
    .string()
    .email("Email must be valid")
    .required("Email is required")
    .trim(),
  primaryNumber: yup
    .string()
    .trim()
    .when("typeOfPatient", {
      is: "outpatient",
      then: (schema) =>
        schema
          .required("Phone Number is required")
          .phone("Invalid Phone Number", "Invalid Phone Number"),
      otherwise: (schema) =>
        // Facility: empty allowed; validate format only when a value is entered
        schema.test(
          "optional-phone",
          "Invalid Phone Number",
          (value) =>
            !value ||
            value === "" ||
            yup
              .string()
              .phone("Invalid Phone Number", "Invalid Phone Number")
              .isValidSync(value),
        ),
    }),
  secondaryNumber: yup
    .string()
    .phone("Invalid Phone Number", "Invalid Phone Number"),
  landlineNumber: yup
    .string()
    .matches(/^[0-9\s\-\+\(\)]*$/, "Landline must be valid")
    .trim(),
  landlineExtension: yup
    .string()
    .matches(/^[0-9]*$/, "Extension must contain only numbers")
    .trim(),

  // Address
  address : yup
  .string()
  .when("typeOfPatient", {
    is: "outpatient",
    then: (schema) => schema.required("Address is required").trim(),
    otherwise: (schema) => schema.trim(),
  }),
// street: yup
//   .string()
//   .when("typeOfPatient", {
//     is: "outpatient",
//     then: (schema) => schema.required("Street is required").trim(),
//     otherwise: (schema) => schema.trim(),
//   }),

city: yup
  .string()
  .when("typeOfPatient", {
    is: "outpatient",
    then: (schema) => schema.required("City is required").trim(),
    otherwise: (schema) => schema.trim(),
  }),

state: yup
  .string()
  .when("typeOfPatient", {
    is: "outpatient",
    then: (schema) => schema.required("State is required").trim(),
    otherwise: (schema) => schema.trim(),
  }),

  zipCode: yup
  .string()
  .trim()
  .when("typeOfPatient", {
    is: "outpatient",
    then: (schema) =>
      schema
        .required("ZIP Code is required")
        .test(
          "zipcode",
          "Invalid ZIP Code",
          (value) => !!value && /^[0-9]{5}(-[0-9]{4})?$/.test(value),
        ),
    otherwise: (schema) =>
      schema.test("zipcode", "Invalid ZIP Code", (value) => {
        if (!value || value === "") return true; // facility: empty OK
        return /^[0-9]{5}(-[0-9]{4})?$/.test(value);
      }),
  }),


  // Insurance Information
  primaryInsuranceName: yup
    .string()
    .required("Primary Insurance Name is required")
    .trim(),
  primaryInsuranceNumber: yup
    .string()
    .required("Primary Insurance Number is required")
    .trim()
    .max(20, "Insurance Number must be at most 20 characters")
    .matches(/^[a-zA-Z0-9]+$/, "Only alphanumeric characters are allowed"),
  secondaryInsuranceName: yup.string().trim(),
secondaryInsuranceNumber: yup
  .string()
  .trim()
  .max(20, "Insurance Number must be at most 20 characters")
  .matches(/^[a-zA-Z0-9]*$/, "Only alphanumeric characters are allowed"),

  // Medical Information
  dx1: yup.string().required("Primary Diagnosis is required"),
dx2: yup
  .string()
  .when("programs", {
    is: (programs :any) => Array.isArray(programs) && programs.includes("ccm"),
    then: (schema) =>
      schema.required("Secondary Diagnosis is required for CCM"),
    otherwise: (schema) => schema.nullable().optional(),
  }),
  dx3: yup.string().nullable(),
  dx4: yup.string().nullable(),
  dx5: yup.string().nullable(),
  programs: yup
    .array()
    .of(yup.string().trim().required("Program cannot be empty"))
    .min(1, "At least one program is required")
    .required("Programs are required"),
  height_feet: yup.string().trim(),
  height_inch: yup.string().trim(),
});
// .test("height-or-inch", "Height is required", function (values) {
//   const feet = (values as any)?.height_feet?.toString().trim();
//   const inch = (values as any)?.height_inch?.toString().trim();
//   if (feet || inch) return false;
//   // attach the combined message to ONE place:
//   return this.createError({ path: "height_feet", message: "Height is required" });
// });

export type PatientFormData = yup.InferType<typeof patientValidationSchema>;

const alphabetRegex = /^[A-Za-z\s]+$/;
const numberRegex = /^[0-9]+$/;

export const facilitySchema = yup.object().shape({
  name: yup
    .string()
    .matches(alphabetRegex, "Only alphabets are allowed")
    .required("Facility Name is required"),

  organizationId: yup
    .string()
    .matches(alphabetRegex, "Only alphabets are allowed")
    .required("Organization Id is required"),

  street: yup
    .string()
    .matches(alphabetRegex, "Only alphabets are allowed")
    .required("Street is required"),

  city: yup
    .string()
    .matches(alphabetRegex, "Only alphabets are allowed")
    .required("City is required"),

  state: yup
    .string()
    .matches(alphabetRegex, "Only alphabets are allowed")
    .required("State is required"),

  zipcode: yup
    .string()
    .matches(numberRegex, "Only numbers are allowed")
    .length(5, "Zipcode must be 5 digits")
    .required("Zipcode is required"),
});

export const optOutSchema = yup.object({
  program: yup
    .array()
    .of(yup.string())
    .min(1, "At least one program is required")
    .required("Program is required"),

  reason: yup.string().trim().required("Reason is required"),
});

export const questionSchema = yup.object().shape({
  sections: yup
    .array()
    .min(1, "At least one section is required")
    .of(
      yup.object().shape({
        icdCodes: yup
          .array()
          .min(1, "At least one ICD code is required")
          .of(yup.string().required("ICD code is required"))
          .required("ICD codes are required"),
        questions: yup
          .array()
          .min(1, "At least one question is required")
          .of(
            yup.object().shape({
              question: yup
                .string()
                .required("Question text is required")
                .min(3, "Question must be at least 3 characters"),
              type: yup
                .string()
                .required("Answer type is required")
                .oneOf(
                  [
                    "multiple_choice",
                    "single_choice",
                    "single_input",
                    "textarea",
                    "multi_input",
                    "single_select",
                    "multi_select",
                  ],
                  "Invalid answer type",
                ),
              options: yup.array().when("type", {
                is: (type: any) =>
                  type === "multiple_choice" || type === "single_choice",
                then: (schema) =>
                  schema
                    .min(
                      1,
                      "At least one option is required for choice questions",
                    )
                    .of(yup.string().required("Option cannot be empty")),
                otherwise: (schema) => schema.notRequired(),
              }),
            }),
          )
          .required("Questions are required"),
      }),
    )
    .required("Sections are required"),
});


export const ProfileSchema = yup.object({
  name : yup.string().required("Name is required"),
  email: yup
    .string()
    .email("Email must be valid")
    .required("Email is required")
    .trim(),
  alterEmail: yup
    .string()
    .email("Alternate email must be valid")
    .trim(),
phone: yup
  .string()
  .when("role", {
    is: (role :any) => role === "admin",
    then: (schema) =>
      schema
        .nullable()
        .notRequired(), // admin: empty allowed
    otherwise: (schema) =>
      schema
        .required("Phone Number is required")
        .phone("Invalid Phone Number", "Invalid Phone Number"),
  })


})